import {
  IOrderManagementState,
  setIsOrderSearchActive,
  setIsUserPopupModalActive,
} from "@/app_redux/reducers/slices/auth/order_management_slice";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useRouter } from "@/app/hooks/useRouter";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import SolidButton from "@/app/components/ui/Buttons/SolidButton";
import { useOrderManagementStatsAPI } from "@/app/hooks/api_hooks/orders/useOrderStatsAPI";
import { useOrderManagementOrderListAPI } from "@/app/hooks/api_hooks/orders/useOrderListAPI";
import { IOrderManagementFilterBody, IOrderManagementStatsFilterBody } from "@/api_framework/api_modals/Orders";

const SearchComponent = ({ setActive, orderType, onSearch, searchText, setSearchText, order_source }) => {
  const { getRouteKey } = useRouter();
  const routeId = getRouteKey("ORDER_MANAGEMENT", "id");
  const { routeState } = useRouteInfo(routeId);
  const { orderFilter, orderModule } = routeState.state as IOrderManagementState;
  const [showClearButton, setShowClearButton] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const fetchOrderListAPI = useOrderManagementOrderListAPI();
  const fetchStatsAPI = useOrderManagementStatsAPI();
  const dispatch = useDispatch();
  const defaultOrderStatus = orderType === "Rx" ? "rx_pending" : "";

  const handleInputSearch = (e) => {
    setSearchText(e.target.value);
    setShowClearButton(e.target.value !== "");
    if (errorMessage) {
      setErrorMessage(false);
    }
  };

  const handleSearch = () => {
    performSearch();
  };

  const handleClear = () => {
    dispatch(setIsOrderSearchActive(false));
    dispatch(setIsUserPopupModalActive(false));
    setSearchText("");
    setShowClearButton(false);
    const statsBody: IOrderManagementStatsFilterBody = {
      start_date: orderFilter?.start_date,
      end_date: orderFilter?.end_date,
      clinic_id: orderFilter?.clinic_id?.split(","),
      order_source: order_source,
    };
    const requestBody: IOrderManagementFilterBody = {
      clinic_id: orderFilter?.clinic_id?.split(","),
      start_date: orderFilter?.start_date,
      end_date: orderFilter?.end_date,
      order_source: order_source,
      source: orderModule,
      order_status: defaultOrderStatus,
    };
    fetchOrderListAPI(requestBody);
    fetchStatsAPI(statsBody);
    setActive("0");
  };

  const performSearch = () => {
    if (searchText) {
      dispatch(setIsOrderSearchActive(true));
      dispatch(setIsUserPopupModalActive(true));
      onSearch(searchText);
    } else {
      setErrorMessage(true);
      setTimeout(() => {
        setErrorMessage(false);
      }, 3000);
    }
  };

  return (
    <div className="flex w-full flex-col gap-1 lg:max-w-[42rem]">
      <div className="flex w-full flex-col gap-2 sm:flex-row sm:items-center">
        <div className="relative w-full sm:flex-1 lg:w-[20vw] lg:flex-none">
          <input
            type="text"
            className={`h-9 w-full rounded-lg border px-3 pr-10 text-xs text-[#344054] placeholder:text-[#98A2B3] focus:outline-none ${
              errorMessage ? "border-[#F04438] focus:border-[#F04438]" : "border-gray-300 focus:border-[#84CAFF]"
            }`}
            placeholder="Client Name, Number, Item Name, Suborder ID, Order ID"
            value={searchText}
            onChange={(e) => handleInputSearch(e)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                performSearch();
              }
            }}
          />
          {showClearButton && (
            <button
              className="absolute right-2 top-1/2 -translate-y-1/2 bg-transparent text-black"
              onClick={handleClear}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                <path
                  d="M14.25 5.3075L13.1925 4.25L9 8.4425L4.8075 4.25L3.75 5.3075L7.9425 9.5L3.75 13.6925L4.8075 14.75L9 10.5575L13.1925 14.75L14.25 13.6925L10.0575 9.5L14.25 5.3075Z"
                  fill="black"
                />
              </svg>
            </button>
          )}
        </div>
        <SolidButton
          size="XL"
          onButtonClick={handleSearch}
          className="h-9 w-full whitespace-nowrap bg-black text-white hover:bg-[#111827] sm:w-[96px]"
        >
          Search
        </SolidButton>
      </div>
    </div>
  );
};

export default SearchComponent;
